import type {AtsEntity} from 'src/types/ats-entities';
import type {AudienceCSVListActions} from 'src/action-creators/audience-csv-list';
import type {
  Sort,
  CSVListTableEntry,
  LeadEntitiesUniqueKey,
  LeadEntitiesAttributes,
} from 'src/types/audience-csv-list';

import {
  RECEIVE_CSV_LISTS,
  RECEIVE_UNIQUE_KEY,
  RECEIVE_LEAD_ENTITIES,
  RECEIVE_CSV_LIST_SORT,
  RECEIVE_CSV_LIST_QUERY,
  RECEIVE_CSV_LIST_FILTER,
  RECEIVE_CSV_LIST_REFETCH,
  RECEIVE_ENTITY_ATTRIBUTES,
  RECEIVE_ENTITIES_UNIQUE_KEY,
  RECEIVE_CSV_LIST_PAGE_NUMBER,
} from 'src/action-creators/audience-csv-list';


export type AudienceCSVListState = {
  // Lists
  lists: Array<CSVListTableEntry>;
  listsMap: Map<number, Array<CSVListTableEntry>>;
  totalLists: number;
  pageNumber: number;
  totalPages: number;
  // Dependency
  leadEntities: Array<AtsEntity>;
  leadEntityAttributes: LeadEntitiesAttributes;
  leadEntitiesUniqueKey: LeadEntitiesUniqueKey;
  // Filters
  sort: Sort;
  query: string;
  refetch: boolean;
  otherFilters: Partial<{
    status: Array<string>;
    entity: Array<string>;
  }>;
};

const initialState = {
  // Lists
  lists: [],
  listsMap: new Map(),
  totalLists: 0,
  pageNumber: 1,
  totalPages: 1,

  // Dependency
  leadEntities: [],
  leadEntityAttributes: {},
  leadEntitiesUniqueKey: {},

  // Filters
  sort: {sortBy: 'lastUserActionAt', sortOrder: 'desc'},
  query: '',
  refetch: false,
  otherFilters: {status: [], entity: []},
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly lists: readonly []; readonly listsMap: Map<any, any>; readonly totalLists: 0; readonly pageNumber: 1; readonly totalPages: 1; readonly leadEntities: readonly []; readonly leadEntityAttributes: {}; ... 4 more ...; readonly otherFilters: { ...; }; }' is not assignable to type 'AudienceCSVListState'.
  state: AudienceCSVListState = initialState,
  action: AudienceCSVListActions,
): AudienceCSVListState => {
  switch (action.type) {
    case RECEIVE_CSV_LISTS: {
      const {totalLists, totalPages, pageNo, lists, isNew} = action.payload;
      const listsMap = isNew ? new Map() : new Map(state.listsMap);

      return {
        ...state,
        lists,
        listsMap: listsMap.set(pageNo, lists),
        totalLists,
        totalPages,
      };
    }
    case RECEIVE_UNIQUE_KEY: {
      const {entity_type, unique_key} = action.payload;
      return {
        ...state,
        leadEntitiesUniqueKey: {
          ...state.leadEntitiesUniqueKey,
          [entity_type]: unique_key,
        },
      };
    }
    case RECEIVE_LEAD_ENTITIES: {
      return {
        ...state,
        leadEntities: action.payload,
      };
    }
    case RECEIVE_CSV_LIST_SORT: {
      return {
        ...state,
        pageNumber: 1,
        sort: action.payload,
      };
    }
    case RECEIVE_CSV_LIST_QUERY: {
      return {
        ...state,
        pageNumber: 1,
        query: action.payload,
      };
    }
    case RECEIVE_CSV_LIST_FILTER: {
      const {field, value} = action.payload;
      return {
        ...state,
        pageNumber: 1,
        otherFilters: {
          ...state.otherFilters,
          [field]: value || [],
        },
      };
    }
    case RECEIVE_CSV_LIST_REFETCH: {
      return {
        ...state,
        pageNumber: 1,
        refetch: !state.refetch,
      };
    }
    case RECEIVE_ENTITY_ATTRIBUTES: {
      const {entityType, attributes} = action.payload;
      return {
        ...state,
        leadEntityAttributes: {
          ...state.leadEntityAttributes,
          [entityType]: attributes,
        },
      };
    }
    case RECEIVE_ENTITIES_UNIQUE_KEY: {
      return {
        ...state,
        leadEntitiesUniqueKey: action.payload,
      };
    }
    case RECEIVE_CSV_LIST_PAGE_NUMBER: {
      return {
        ...state,
        pageNumber: action.payload,
      };
    }
  }

  return state;
};
